import Table100 from "./Table100/Table100";
import Table200 from "./Table200/Table200";
import Table500 from "./Table500/Table500";
import Table500above from "./Table500above/Table500above";

const Table5 = () => {
    return (
        <div className="mt-5">
            <h2 className="fw-bold fs-4 text-center">BẢNG 5: BIỂU PHÍ POS – áp dụng với khách hàng lớn sử dụng dịch vụ từ ngân hàng BIDV</h2>
            <Table100 />
            <Table200 />
            <Table500 />
            <Table500above />
        </div>

    );
};
export default Table5;